// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 335 ? "cdbf2551" : chunkId) + "." + {"1":"1bfecd5a7069e4a6","139":"e0b8da9815ba2cf2","277":"a6aa604007a310de","335":"fe98bf5480223340"}[chunkId] + ".js";
};